import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Card, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import BasicPagination from "../../pagination/BasicPagination";
import { useIsAccessAllow } from "../../users/redux";
import { getAllAuthorAsync, deleteAuthorAsync, AuthorManagementActions } from "../redux";

export function HdpAuthor() {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchRef = useRef();
  const { isLoading, authorListTotal, skip = 0, limit = 10, searchBy, searchText, refreshAuthor } = useSelector(
    (state) => state.hdp_author || {},
    shallowEqual
  );

  useEffect(() => {
    if (searchRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(AuthorManagementActions.refreshAuthorList());
        }
      };
      let input = searchRef.current;
      input.addEventListener("keyup", keyPressEvent);
      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(AuthorManagementActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (refreshAuthor) {
      dispatch(getAllAuthorAsync(searchBy, searchText));
    }
    // eslint-disable-next-line
  }, [refreshAuthor]);

  const onSearchTextChange = (e) => {
    dispatch(AuthorManagementActions.searchTextChange(e.target.value));
  };

  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(AuthorManagementActions.setAuthorBatchNumber(count));
  };

  const onEditClick = (data) => {
    history.push(`/hdp_author/edit-author/${data?._id}`);
  };

  const onDeleteClick = (data) => {
    if (window.confirm("Are you sure you want to delete?")) {
      dispatch(deleteAuthorAsync(data?._id));
      dispatch(getAllAuthorAsync(searchBy, searchText));
    }
  };

  const isAddAllow = useIsAccessAllow("hdp_author.add_author");
  const isListAllow = useIsAccessAllow("hdp_author.list");
  const isEditAllow = useIsAccessAllow("hdp_author.edit_author");
  const isDeleteAllow = useIsAccessAllow("hdp_author.delete_author");

  return (
    <Card>
      <CardHeader title="HDP Author">
        <CardHeaderToolbar>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <form className="subheader_filter" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                {isAddAllow && (
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button className="btn_new btn-sm" type="button" onClick={() => history.push("/hdp_author/add-author")}>
                      Add
                    </button>
                  </div>
                )}
                {isListAllow && (
                  <div className="form-group mr-3 mb-1">
                    <input
                      name="Search"
                      placeholder="Search. . ."
                      type="text"
                      className="form-control"
                      value={searchText || ""}
                      autoComplete="off"
                      onChange={onSearchTextChange}
                      ref={searchRef}
                    />
                  </div>
                )}
              </div>
            </form>
          </div>
        </CardHeaderToolbar>
      </CardHeader>
      <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <div className="tblmrgn mt-0">
          <div className="mt-5">
            <Table hover responsive className="mb-0 default_table with_hoverbtn mrpdng_tbl">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Author Name</th>
                  <th>Description</th>
                  <th>Created On</th>
                  <th width="140">Action</th>
                </tr>
              </thead>
              <tbody>
                {authorListTotal && authorListTotal.records && authorListTotal.records.length ? (
                  authorListTotal.records.map((author, index) => (
                    <tr key={index}>
                      <td><span>{skip * limit + (index + 1)}</span></td>
                      <td><span>{author.authorName}</span></td>
                      <td><span>{author.authorDescription}</span></td>
                      <td><span>{new Date(author.createdOn).toLocaleString()}</span></td>
                      <td>
                        {isEditAllow && (
                          <button
                            title="Edit"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            onClick={() => onEditClick(author)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")} />
                            </span>
                          </button>
                        )}
                        {isDeleteAllow && (
                          <button
                            title="Delete"
                            className="btn btn-icon btn-light btn-hover-danger btn-sm"
                            onClick={() => onDeleteClick(author)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-danger">
                              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                            </span>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">No Record Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
            {!isLoading && authorListTotal && (
              <div className="row d-flex align-items-center mr-5 ml-5 mt-4">
                <div className="col-md-8 text-right mb-5 aspgntn">
                  <BasicPagination
                    totalRecords={authorListTotal.recordsTotal || 0}
                    limit={limit}
                    batch={skip + 1}
                    onBatchChange={onPageChange}
                  />
                </div>
                <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-right">
                  Displaying {skip * limit + 1} - {skip * limit + limit} of {authorListTotal.recordsTotal || 0} Records
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
